import Lucide from "./Lucide.vue";

export default Lucide;
